import { gql } from 'graphql-query-contracts';

export const updateChannelModuleMutation = gql(`
  mutation updateChannelModule($channelModule: ChannelModuleInput!) {
    updateChannelModule(channelModule: $channelModule) {
      _id
      name
      friendlyName
      description
      availableFeatures
      allowsMultipleInstances
      autoCreatesContent
      createsAdminPage
      disabled
      dataDefinition
      contentType
      channelId
    }
  }
`);
